import React from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

export default function MyComponent({ data }) {
  return (
    <div className="App">
      <div className="content" />
      <VisibilitySensor partialVisibility offset={{ bottom: 0 }}>
        {({ isVisible }) => (
          <div style={{ height: 50 }}>
            <h2 style={{ color: "black" }}>
              {data.name}{" "}
              {isVisible ? (
                <CountUp end={data.num} duration={4} useEasing={true} />
              ) : null}
              +
            </h2>
          </div>
        )}
      </VisibilitySensor>
    </div>
  );
}
